import { DbKey } from '../../../../../adl-gen/common/db';
import { ApplicationRole, AppUser, AppUserStatus } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { UserGroupListEntry } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { ListEntryWithIdentity, ListFieldInfo } from '../../../common/list/list-types';

export type GroupAppUserListEntry = ListEntryWithIdentity<AppUser>;

export interface GroupAppUsers {
  userGroup?: UserGroupListEntry;
  members: DbKey<AppUser>[];
  managers: DbKey<AppUser>[];
}

/** Display information for Users */
export const GroupAppUserListView: ListFieldInfo<GroupAppUserListEntry, GroupAppUsers>[] = [
  {
    name: 'fullname',
    label: 'Name',
    kind: 'text',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'role',
    label: 'User Type',
    kind: 'mapped',
    displayed: false,
    sortable: false,
    map: entry =>
      entry.role === ApplicationRole.super ? 'super' : entry.role === ApplicationRole.admin ? 'admin' : 'user',
    align: 'centre'
  },
  {
    name: 'status',
    label: 'Active',
    kind: 'checkItem',
    displayed: true,
    toggle: entry => entry.status === AppUserStatus.active,
    align: 'centre'
  },
  {
    name: 'member',
    label: 'Group Member',
    kind: 'toggle',
    toggle: (entry, users?: GroupAppUsers) => {
      if (users !== undefined) {
        return users.members.includes(entry.id);
      }
      return false;
    },
    disabled: (entry, users?: GroupAppUsers) => {
      // Disable client admins if usergroup is global
      if (entry.identity === 'client-admin') {
        if (users && users.userGroup) {
          return users.userGroup.isGlobal;
        }
        return false;
      }
      return false;
    },
    displayed: true,
    align: 'centre'
  },
  {
    name: 'manager',
    label: 'Group Manager',
    kind: 'toggle',
    toggle: (entry, users?: GroupAppUsers) => {
      if (users !== undefined) {
        return users.managers.includes(entry.id);
      }
      return false;
    },
    displayed: true,
    align: 'centre'
  }
];

export const UnassignedAppUserListView: ListFieldInfo<GroupAppUserListEntry, GroupAppUsers>[] = [
  {
    name: 'fullname',
    label: 'Name',
    kind: 'text',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'role',
    label: 'User Type',
    kind: 'mapped',
    displayed: false,
    sortable: false,
    map: entry =>
      entry.role === ApplicationRole.super ? 'super' : entry.role === ApplicationRole.admin ? 'admin' : 'user',
    align: 'centre'
  },
  {
    name: 'status',
    label: 'Active',
    kind: 'checkItem',
    displayed: true,
    toggle: entry => entry.status === AppUserStatus.active,
    align: 'centre'
  },
  {
    name: 'member',
    label: 'Group Member',
    kind: 'toggle',
    toggle: (entry, users?: GroupAppUsers) => {
      if (users !== undefined) {
        return users.members.includes(entry.id);
      }
      return false;
    },
    displayed: true,
    align: 'centre'
  },
  {
    name: 'manager',
    label: 'Group Manager',
    kind: 'toggle',
    toggle: (entry, users?: GroupAppUsers) => {
      if (users !== undefined) {
        return users.managers.includes(entry.id);
      }
      return false;
    },
    displayed: true,
    align: 'centre'
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/appuser-list/group-appuser-list-view.ts